import { ExperimentActions } from '@src/types/actions'
import { getType } from 'typesafe-actions'
import { CONTROL } from '.'
import { setExperimentVariant } from './actions'

export interface ExperimentState {
  variant: string | undefined
}

const initialState: ExperimentState = {
  variant: CONTROL,
}

const experimentReducer = (
  state: ExperimentState = initialState,
  action: ExperimentActions
) => {
  switch (action.type) {
    case getType(setExperimentVariant): {
      return {
        ...state,
        variant: action.payload.variant,
      }
    }
    default:
      return state
  }
}

export default experimentReducer



// WEBPACK FOOTER //
// ./src/state/experiment/reducer.ts